import React from "react"
import { connect } from "react-redux"
import styled from "styled-components"
import * as authActions from "../../auth/actions"
import { responsive } from "buoy-theme"
import AuthForm from "./AuthForm"
import { authFormConfig } from "./authFormConfig"
import { validateEmail } from "../../common/common"
import { CardStyle } from "buoy-core"

const loginResetConfig = { status: "", msg: "" }

const FormContainer = styled.div`
  ${CardStyle};
  border-top: none;
  ${responsive("padding", "0 24px", "0 24px", "0 24px", "0 24px", "0 16px")};
  margin-bottom: 16px;
  width: 100%;
`

class DashboardAuth extends React.Component {
  state = {
    showLogin: false,
  }

  componentDidUpdate = (prevProps, prevState) => {
    if (prevState.showLogin !== this.state.showLogin) {
      this.props.resetError(this.state.showLogin)
    }
  }

  onSubmit = password => {
    if (this.state.showLogin) {
      this.props.login(password)
    } else {
      this.props.signUp()
    }
  }

  toggleFormDisplay = () => {
    this.props.onEmailChange("")
    this.setState({
      showLogin: !this.state.showLogin,
    })
  }

  render() {
    let disabled = !validateEmail(this.props.email)
    let authError = this.state.showLogin ? this.props.loginError : this.props.signupError
    // disables auth form submission for /demo/ page
    let disableAuthForm = window.location.pathname.startsWith("/demo")
    return (
      <FormContainer>
        <AuthForm
          onEmailChange={this.props.onEmailChange}
          onSubmit={this.onSubmit}
          toggleFormDisplay={this.toggleFormDisplay}
          email={this.props.email}
          formConfig={authFormConfig}
          disabled={disabled || disableAuthForm}
          disableAuthForm={disableAuthForm} //disables forgot password link for demo
          authError={authError}
          {...this.state}
        />
      </FormContainer>
    )
  }
}

const mapStateToProps = state => ({
  email: state.auth.email,
  signupError: state.auth.status.signup,
  loginError: state.auth.status.login
})

const mapDispatchToProps = dispatch => ({
  login: password => dispatch(authActions.loginSubmit(password)),
  onEmailChange: email => dispatch(authActions.setEmail(email)),
  signUp: () => dispatch(authActions.signup()),
  resetError: login => {
    if (login) {
      dispatch(authActions.setSignupStatus(loginResetConfig))
    }
    dispatch(authActions.setLoginStatus(loginResetConfig))
  },
})

const DashboardAuthWrapper = connect(mapStateToProps, mapDispatchToProps)(
  DashboardAuth
)

export { DashboardAuthWrapper as default }



// WEBPACK FOOTER //
// ./assets/dashboard/components/DashboardAuth.js